// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapLongText--FWyFr {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}

.textCenter--bxS6e {
  text-align: center;
}

.rightShadow--SbCvE {
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.1);
}

.header--OS6zt {
  background: linear-gradient(#002984, #3f51b5);
  box-shadow: 0 0 5px rgb(0, 0, 0);
  position: relative;
  height: 160px;
  padding: 30px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.header--OS6zt .title--LgJwz,
.header--OS6zt .subtitle--KKJrf {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  letter-spacing: 0;
  color: #fff;
}
.header--OS6zt .title--LgJwz {
  font-size: 26px;
  line-height: 30px;
  margin-right: 12px;
}
.header--OS6zt .subtitle--KKJrf {
  font-size: 16px;
  line-height: 19px;
  opacity: 0.79;
  margin-top: 12px;
}
.header--OS6zt .closeButton--roZgG {
  color: #fff;
  position: absolute;
  right: 12px;
  top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/global.scss","webpack://./src/app/widgets/chatHeaders/a24GroupHeaderLarge/a24GroupHeaderLarge.scss"],"names":[],"mappings":"AAeA;EACE,yBAAA;EACA,qBAAA;EACA,yBAAA;EAEA,sEAAA;EACA,qBAAA;EAEA,uCAAA;EACA,sBAAA;EAEA,iEAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;ACjBF;;ADoBA;EACE,kBAAA;ACjBF;;ADoBA;EACE,wCAAA;ACjBF;;AAlBA;EACE,6CAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAqBF;AAnBE;;EAEE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AAqBJ;AAlBE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAoBJ;AAjBE;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AAmBJ;AAhBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAkBJ","sourcesContent":["@import '~@material/theme/_color-palette.scss';\n@import '~@material/theme/_variables.scss';\n\n$mdc-theme-primary: #3f51b5;\n$mdc-theme-primary-light: #757de8;\n$mdc-theme-primary-dark: #002984;\n$mdc-theme-secondary: #ffab00;\n$mdc-theme-secondary-light: #ffdd4b;\n$mdc-theme-secondary-dark: #c67c00;\n$mdc-theme-background: #f6f6f6;\n$mdc-theme-surface: #fff;\n$ember-background-color: #eee;\n\n// global classes\n\n:local(.wrapLongText) {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n\n  /* Adds a hyphen where the word breaks, if supported (No Blink) */\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n\n:local(.textCenter) {\n  text-align: center;\n}\n\n:local(.rightShadow) {\n  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.1);\n}\n","@import '../../../global.scss';\n@import '~@material/drawer/_variables.scss';\n\n:local(.header) {\n  background: linear-gradient($mdc-theme-primary-dark, $mdc-theme-primary);\n  box-shadow: 0 0 5px rgba(0, 0, 0, 11);\n  position: relative;\n  height: 160px;\n  padding: 30px 40px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n\n  :local(.title),\n  :local(.subtitle) {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    letter-spacing: 0;\n    color: #fff;\n  }\n\n  :local(.title) {\n    font-size: 26px;\n    line-height: 30px;\n    margin-right: 12px;\n  }\n\n  :local(.subtitle) {\n    font-size: 16px;\n    line-height: 19px;\n    opacity: 0.79;\n    margin-top: 12px;\n  }\n\n  :local(.closeButton) {\n    color: #fff;\n    position: absolute;\n    right: 12px;\n    top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapLongText": `wrapLongText--FWyFr`,
	"textCenter": `textCenter--bxS6e`,
	"rightShadow": `rightShadow--SbCvE`,
	"header": `header--OS6zt`,
	"title": `title--LgJwz`,
	"subtitle": `subtitle--KKJrf`,
	"closeButton": `closeButton--roZgG`
};
export default ___CSS_LOADER_EXPORT___;
